<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/qingbaijiang/2/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            设立“引才伯乐奖”，对我区单位和个人（企业、社会组织、猎头机构、“海外荐才大使”）每引育一名ABC类及海外人才的，给予最高50万元奖励支持。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="../../assets/imgs/25/title-1.png" alt="" />
          <div class="content" style="padding-bottom: 0.3rem;">
            <span class="hollow-cricle"></span
            ><span class="title" style="font-size: 0.33rem;">申请对象需同时满足以下条件：</span>
            <div class="des">（一）申报单位符合我区主导产业发展方向，注册地和主要纳税关系均在我区；</div>
            <div class="des">（二）申报单位引进培育的人才需属于ABC类及海外人才范围，具体人才类别按照《成都市人才分类目录》及《成都市海外引才“直通车”工作机制》执行；</div>
            <div class="des">（三）引进培育人才全职在企业工作的，企业需与人才签订3年以上（含3年）的，每年不低于9个月的正式劳动合同，且在我区缴纳社保和个税；</div>
            <div class="des">（四）企业柔性引进人才的，需与人才签订3年以上（含3年）的，每年不低于3个月的正式工作合同（含技术合作协议、项目合作协议），合同需明确具体的工作目标任务；</div>
            <div class="des">（五）企业引进培育的人才在技术攻关、市场开拓、营收增长等方面做出突出贡献。</div>
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="../../assets/imgs/qingbaijiang/2/title-2.png" alt="" />
          <div class="content" style="padding-bottom: 0.3rem;">
            <div class="des">（一）每新引进和培育1名ABC类人才全职在我区工作的，分别给予用人企业50万元、20万元、10万元奖励支持；每新柔性引进1名ABC类人才，分别给予用人企业25万元、10万元、5万元奖励支持。</div>
            <div class="des">（二）每新引进1名海外人才全职在我区工作的，给予用人企业、社会组织、猎头机构、“海外荐才大使”1万元，且最高不超过5万元的奖励支持。</div>
            <div class="des">（三）企业可将相关奖励用于支持在引育海外人才方面有突出贡献的个人。</div>
          </div>
        </div>
        <div class="gmlc">
          <img class="top" src="../../assets/imgs/25/title-3.png" alt="" />
          <div class="content">
            <div class="des mar-t3">
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">1</div>
                  <div class="line-title">申报</div>
                </div>
                <div class="line-content">
                  人才所在企业向人才工作科提出申请。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">2</div>
                  <div class="line-title">受理</div>
                </div>
                <div class="line-content">
                  人才工作科对申报材料进行形式审查，合格的，予以受理；不合格的，现场向申请机构作出说明并退回申请材料。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">3</div>
                  <div class="line-title">审核</div>
                </div>
                <div class="line-content">
                  区委组织部（区委人才办）牵头会同企业所属产业园区、镇街等载体单位，行业主管部门、税务部门、第三方专业机构对申请材料进行审核。审核通过后，按程序报区委人才工作领导小组会议审定。
                </div>
              </div>
              <div class="line-item">
                <div class="line-top">
                  <div class="line-num">4</div>
                  <div class="line-title">资金拨付</div>
                </div>
                <div class="line-content">
                  审定通过后，区委组织部（区委人才办）按程序将相关资金拨予载体单位，由载体单位向企业发放。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.8rem">
          <img class="top" src="../../assets/imgs/25/title-4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028—61760181">028—61760181</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
            <div class="site">
              <span class="label">地址：</span>
              青江中路183号
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/54/code.png" />
          <img class="text" src="../assets/imgs/54/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.5rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        // font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;

        text-align: left;
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.4rem;
        .title {
          font-size: 0.35rem;
          color: #333;
          font-weight: 600;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem;
          padding: 0.22rem;
          font-weight: 500;
          margin-top: 0.25rem;
          position: relative;
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;
      // line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.59rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3A73FF;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.75rem;
      }
    }
  }
}
</style>
